<template>
	<div class="ranklist">
        <div class="ranklist_my">
            <van-image round width="1.23rem" height="1.23rem" :src="rankList.userInfo.avatar"></van-image>
            <div class="ranklist_my_info">
                <div class="ranklist_my_info_new">
                    <div class="ranklist_my_info_name">{{rankList.userInfo.nickname}}</div>
                    <div class="ranklist_my_info_rank" v-if="rankList.userInfo.rank>0">排行第{{rankList.userInfo.rank}}名</div>
                </div>
                <!-- <div class="ranklist_my_info_id">
                    ID：wxid53988
                </div>  -->   
            </div>
            <div class="ranklist_my_vote">
                <span>{{rankList.userInfo.votes}}</span> 票
            </div>
        </div>
		<div v-for="(item,key) in rankList.front3" :key="key" class="item_ranklist">      
            <div class="item_ranklist_info">
                <van-image width="0.385rem" height="0.49rem" :src="require('@/assets/img/family/'+item.rank+'.png')"></van-image>
                <div class="item_ranklist_person">
                    <van-image round width="0.71rem" height="0.71rem" :src="item.avatarurl"></van-image>
                    <div class="item_ranklist_name">{{item.name}}</div>
                </div>
            </div>
            <div class="item_ranklist_rank">{{item.votes+' 票'}}</div>    
        </div>
        <div class="item_ranklist" v-for="(item,key) in rankList.list" :key="key" v-if="item">
            <div class="item_ranklist_info">
                <div class="rank">{{item.rank}}</div>
                <div class="item_ranklist_person">
                    <van-image round width="0.71rem" height="0.71rem" :src="item.avatarurl"></van-image>
                    <div class="item_ranklist_name">{{item.name}}</div>
                </div>
            </div>
            <div class="item_ranklist_rank">{{item.votes+' 票'}}</div>
        </div>
	</div>
</template>
<script>
    import './index.less'
    import { Image } from 'vant'; 
    export default {
        name:"rankList",
        props:{
            rankList:Object
        },
        components:{
            vanImage:Image
        },
        methods: {
            goDetail:function (val) {
                // console.log(val)
                this.$emit('goDetail',val);
            }
        },
        mounted(){
            this.$nextTick(()=>{
                
            })
        }
    }
</script>